import constants from 'app/constants'
import { ERROR_CODE } from 'app/util/errorCodes'
import fetchJSONData from 'app/util/fetchJSONData'
import { API_ERROR_RESPONSE_MESSAGE, API_RESPONSE } from './constants'

/**
 * Submit apply sign up
 *
 * @param {object} formData - the form submission data
 * @returns {object} the response
 */
const submitSignUpApply = async formData => {
  const {
    email,
    firstName,
    lastName,
    referrer,
    telegram,
    twitter
    /*
    daily_style,
    dressing,
    expression,
    outfit,
    spend_habit,
    style,
    uniqueness */
  } = formData

  const data = {
    email,
    firstName,
    lastName,
    telegram: telegram || '',
    twitter: twitter || '',
    referrer: referrer || '',
    submit: 'user',
    network: constants.NETWORK
  }

  // Updated form
  /* const data = {
    email,
    firstName,
    lastName,
    telegram: telegram || '',
    twitter: twitter || '',
    referrer: referrer || '',
    daily_style: daily_style || '',
    expression: expression || '',
    style: style || '',
    spend_habit: spend_habit || '',
    uniqueness: uniqueness || '',
    outfit: outfit || '',
    dressing: Array.isArray(dressing || '') ? dressing : [dressing || ''],
    dream_avatar,
    submit: 'user'
  } */

  let res

  try {
    const { data: outputData, success } = await fetchJSONData(
      `${constants.API_URL}/wl/early`,
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      }, false
    )

    if (!success) {
      throw new Error('Failed to apply')
    }

    res = outputData
  } catch (e) {
    console.error(e)

    return {
      success: false,
      message: ERROR_CODE.UNKNOWN
    }
  }

  if (res?.message === API_RESPONSE.SIGNED_UP) {
    return {
      success: true
    }
  }

  return {
    success: false,
    message: API_ERROR_RESPONSE_MESSAGE[res?.message] || ERROR_CODE.UNKNOWN
  }
}

// Export
export default submitSignUpApply
